// extracted by mini-css-extract-plugin
module.exports = {"productDetailWrapper":"SpecsItem_productDetailWrapper__qaXHh","theme_white":"SpecsItem_theme_white__JW7t5","theme_black":"SpecsItem_theme_black__ynRev"};